var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"panel-group"},[_c('el-col',[_c('div',{staticClass:"card-panel"},[_c('el-card',{staticClass:"card-panel-inside"})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }